import axios from "axios";

export const API_URL = `${process.env.REACT_APP_API_URL}/merchantitems`;

// CREATE =>  POST: add a new product to the server
export function createMerchantItem(merchantitem) {
    return axios.post(API_URL, { ...merchantitem });
}

// READ
export function getAllMerchantItems() {
    return axios.get(API_URL);
}

export function getPaginatedMerchantItems(queryParams) {
    return axios.post(`${API_URL}/list`, { ...queryParams });
}

export function getMerchantItemById(merchantitemId) {
    return axios.get(`${API_URL}/${merchantitemId}`);
}



// // Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// // items => filtered/sorted result
// export function findProducts(queryParams) {
//     return axios.post(`${API_URL}/find`, { queryParams });
// }

// UPDATE => PUT: update the merchantitem on the server
export function updateMerchantItem(merchantitemId, merchantitem) {
    return axios.put(`${API_URL}/${merchantitemId}`, { ...merchantitem });
}


// DELETE => delete the product from the server
export function deleteMerchantItem(merchantitemId) {
    return axios.delete(`${API_URL}/${merchantitemId}`);
}
